module.exports = __webpack_public_path__ + "static/media/alvin_dp_1.e44b3b0b.png";